export default "__VITE_ASSET__b0ffad2f__"